import { SkeletonBlock, SkeletonContainer } from './styles';
import React from 'react';

export interface SkeletonProps {
  boneNumber?: number;
}

export const HistoryItemSkeleton = ({ boneNumber = 2 }: SkeletonProps) => {
  const skeletonPlaceholder = Array.from(Array(boneNumber).keys());

  return (
    <SkeletonContainer>
      {skeletonPlaceholder.map((bone) => (
        <SkeletonBlock key={bone} data-testid="history-item-skeleton" />
      ))}
    </SkeletonContainer>
  );
};
